export default "__VITE_ASSET__U49EN5_d__"